export default __webpack_public_path__ + "alberta-unlock.5de2fbbb782aff116c39.svg";